export default {"src":"/_next/static/media/plus_filled.2fb3d072.svg","height":24,"width":24};